// @flow
import CompetitionMedia from 'components/competition/CompetitionMedia';
import { connect } from 'react-redux';

import type { StateProps } from 'components/competition/CompetitionMedia';
import type { StateType } from 'types/Actions';

export default connect((state: StateType): StateProps => ({
  medias: state.competitionState.competition.medias
}))(CompetitionMedia);
